import Model from "../Model";

class Companybubbledetails extends Model{

    buildUrl ({ param }) {
        return ['companyview/getotherbubbles', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Companybubbledetails;